export default __webpack_public_path__ + "static/media/hive exchange white 1.01e9cd74.svg";